import React from "react";
import { Seo } from "../components/Seo";
import { BreadcrumbLd } from "../components/BreadcrumbLd";
import { Link } from "react-router-dom";

export default function PonyClub() {
  const images = [
    { src: "/img/portfolio/ponyclub_img_1.jpg", alt: "Niños montando en poni" },
    { src: "/img/portfolio/ponyclub_img_2.jpg", alt: "Clases de iniciación" },
    {
      src: "/img/portfolio/ponyclub_img_3.jpg",
      alt: "Paseo en poni con amigos",
    },
    {
      src: "/img/portfolio/ponyclub_img_4.jpg",
      alt: "Zona de juegos con ponis",
    },
    { src: "/img/portfolio/ponyclub_img_5.jpg", alt: "Actividades educativas" },
  ];

  return (
    <div id="ponyclub" className="text-center">
      <Seo
        title="Pony Club | Equitación para los más pequeños"
        description="Actividades y clases con ponis para niñas y niños con monitores especializados y máxima seguridad."
        path="/pony-club"
        image="https://madridcampogrande.es/og/default.jpg"
      />
      <BreadcrumbLd
        items={[
          { name: "Inicio", path: "/" },
          { name: "Pony Club", path: "/pony-club" },
        ]}
      />
      <div className="container">
        <div className="section-title" style={{ marginBottom: 16 }}>
          <h2 style={{ marginBottom: 8 }}>Pony Club</h2>
          <p style={{ maxWidth: 820, margin: "0 auto" }}>
            Ven a disfrutar con tus amigos los ponis.
          </p>
        </div>

        <div className="row" style={{ marginBottom: 24 }}>
          <div className="col-md-10 col-md-offset-1">
            <p style={{ fontSize: 16 }}>
              A partir de los <strong>3 años</strong> puedes venir a disfrutar
              dando paseos o clases en las que te iniciarás en el mundo de la
              equitación.
            </p>
            <p style={{ fontSize: 16 }}>
              En Hípica Madrid Campogrande también ofrecemos la posibilidad de
              aprender a montar con ponis para los más pequeños. Para una
              primera toma de contacto con el mundo ecuestre, a través de juegos
              y actividades adaptadas a su edad, los niños aprenden a cuidar,
              montar y convivir con los ponis, desarrollando valores como la
              responsabilidad, el respeto por los animales y el trabajo en
              equipo.
            </p>
          </div>
        </div>

        {/* Galería */}
        <div className="row">
          {images.map((img, i) => (
            <div
              key={i}
              className="col-xs-12 col-sm-6 col-md-4"
              style={{ marginBottom: 20 }}
            >
              <div
                className="gallery-item"
                style={{
                  borderRadius: 12,
                  overflow: "hidden",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                }}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        <p>
          Si quieres revisar los <strong>precios</strong> consulta la sección de{" "}
          <Link to="/escuela-hipica#tarifas">tarifas</Link>.
        </p>
      </div>
    </div>
  );
}
